export class SeidSearchRequest {
    ClientId: string;
    ServiceEventIds: string[] = [];
    limit: number;
    offset: number;
    sort: string;
}
